const STORAGE_NS = "report_panel_scale_pref_v1";
const DEFAULT_SCALE = 1;
const MIN_SCALE = 0.5;
const MAX_SCALE = 1;
const STEP = 0.05;

function isBrowser() {
  return typeof window !== "undefined" && typeof localStorage !== "undefined";
}

function keyOf(userId) {
  if (!userId) return null;
  return `${STORAGE_NS}:${userId}`;
}

function safeParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function normalizeReportPanelScalePref(scale) {
  const numericScale = Number(scale);

  if (!Number.isFinite(numericScale)) {
    return DEFAULT_SCALE;
  }

  const roundedScale = Math.round(numericScale / STEP) * STEP;
  const clampedScale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, roundedScale));

  return Number(clampedScale.toFixed(2));
}

export function getReportPanelScalePref(userId) {
  if (!isBrowser()) return DEFAULT_SCALE;

  const storageKey = keyOf(userId);
  if (!storageKey) return DEFAULT_SCALE;

  const raw = localStorage.getItem(storageKey);
  if (!raw) return DEFAULT_SCALE;

  const parsed = safeParse(raw);
  if (!parsed || parsed.v !== 1) return DEFAULT_SCALE;

  return normalizeReportPanelScalePref(parsed.scale);
}

export function setReportPanelScalePref(userId, scale) {
  if (!isBrowser()) return;

  const storageKey = keyOf(userId);
  if (!storageKey) return;

  const payload = {
    v: 1,
    t: Date.now(),
    scale: normalizeReportPanelScalePref(scale),
  };

  localStorage.setItem(storageKey, JSON.stringify(payload));
}

export const REPORT_PANEL_SCALE_PREF = {
  DEFAULT_SCALE,
  MIN_SCALE,
  MAX_SCALE,
  STEP,
};
